import { ALL_VISION } from 'core/constants/products'
import stickySummary from '../components/plan-summary/sticky'
import store from 'utils/store/withMiddleware'

function deleteVision(e: Event) {
  const state = store.getState()
  const addOns = state.addOns.filter(
    planId => !ALL_VISION.includes(state.plans[planId].productId)
  )

  store.update({ addOns, visionPlanId: undefined })
  e.stopPropagation()
  e.preventDefault()
  stickySummary()
}

export default deleteVision
